/**
 * @fileoverview Small document metadata helper for the multi-surface static SPA.
 * @provides setDocumentMeta for canonical, description, and indexing directives.
 * @usedBy Public campaign, authentication, and authenticated layouts.
 * @uses Browser document APIs only.
 */
export function setDocumentMeta(input: { title: string; description: string; canonical: string; index: boolean }) {
  document.title = input.title;
  const description = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  const robots = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
  const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (description) description.content = input.description;
  if (robots) robots.content = input.index ? "index,follow" : "noindex,nofollow";
  if (canonical) canonical.href = input.canonical;
}
